import FilterTime from "./FilterTime";
import ImageIcon from "./ImageIcon";
import MultipleSelect from "./MultipleSelect";
import NoData from "./NoData";
import Pagination from "./Pagination";
import RouterLink from "./RouterLink";
import SearchText from "./SearchText";
import TextCopy from "./TextCopy";
import PasswordStrength from "./PasswordStrength";
import NotifyButton from "./NotifyButton";
import PolicyResult from "./PolicyResult";
import UserInfo from "./UserInfo";
import Attachment from "./Attachment";
import DocLink from "./DocLink";

const itemsComponents = {
  FilterTime,
  ImageIcon,
  MultipleSelect,
  NoData,
  Pagination,
  RouterLink,
  SearchText,
  TextCopy,
  PasswordStrength,
  NotifyButton,
  PolicyResult,
  UserInfo,
  Attachment,
  DocLink
}

export default itemsComponents